<template>
    <section id="cta-51">
      <div class="cs-container">
        <div class="cs-content">
          <h2 class="cs-title">Ready to Receive Compassionate and Reliable Support?</h2>
          <p class="cs-text">
            At Ajonee Disability Support Services, we are here to help you or your loved ones live with dignity, independence, and joy. Whether you need daily assistance, community participation, or specialized care, our team is ready to support you.
          </p>
          <a href="/contact" class="cs-button-solid">Contact Us</a>
        </div>
      </div>
      <!-- Background Image-->
      <picture class="cs-picture">
        <source media="(max-width: 600px)" srcset="../assets/images/home-4.jpg">
        <source media="(min-width: 601px)" srcset="../assets/images/home-4.jpg">
        <img loading="lazy" decoding="async" src="../assets/images/home-4.jpg" alt="cabinets" width="1920" height="1280" aria-hidden="true">
      </picture>
    </section>
  </template>
  
  <script>
  export default {
    name: "CallToActionSection"
  };
  </script>
  
  <style scoped>

/*-- -------------------------- -->
<---            CTA             -->
<--- -------------------------- -*/

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
#cta-51 {
    padding: var(--sectionPadding);
    position: relative;
}
#cta-51 .cs-container {
    width: 100%;
    max-width: 80rem;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* 48px - 64px */
    gap: clamp(3rem, 6vw, 4rem);
}
#cta-51 .cs-content {
    /* set text align to left if content needs to be left aligned */
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
    /* centers content horizontally, set to flex-start to left align */
    align-items: center;
}

#cta-51 .cs-title {
    color: var(--bodyTextColorWhite);
}
#cta-51 .cs-text {
    margin-bottom: 1rem;
    color: var(--bodyTextColorWhite);
    opacity: 0.8;
}
#cta-51 .cs-text:last-of-type {
    margin-bottom: 2rem;
}
#cta-51 .cs-button-solid {
    font-size: 1rem;
    /* 46px - 56px */
    line-height: clamp(2.875rem, 5.5vw, 3.5rem);
    text-decoration: none;
    font-weight: 700;
    text-align: center;
    margin: 0;
    color: #fff;
    min-width: 9.375rem;
    padding: 0 1.5rem;
    background-color: var(--primary);
    border-radius: 0.25rem;
    display: inline-block;
    position: relative;
    z-index: 1;
    /* prevents padding from adding to the width */
    box-sizing: border-box;
}
#cta-51 .cs-button-solid:before {
    content: "";
    position: absolute;
    height: 100%;
    width: 0%;
    background: #000;
    opacity: 1;
    top: 0;
    left: 0;
    z-index: -1;
    border-radius: 0.25rem;
    transition: width 0.3s;
}
#cta-51 .cs-button-solid:hover:before {
    width: 100%;
}
#cta-51 .cs-picture {
    height: 100%;
    width: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
}
#cta-51 .cs-picture:before {
    /* black color overlay */
    content: "";
    position: absolute;
    display: block;
    height: 100%;
    width: 100%;
    background: #000;
    opacity: 0.8;
    top: 0;
    left: 0;
    z-index: 1;
}
#cta-51 .cs-picture img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
}
}

  </style>
  